var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('GlobalLoading'),_c('Navbar'),_c('CallMe'),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }